import { VARIANTS } from 'shared_DEPRECATED/components/Button';
import { noop } from 'shared_DEPRECATED/utils/function';

import { ModalBody, ModalHeader, ModalFooter } from 'shared/components/Modal';
import { ModalButton } from 'shared/components/Modal/ModalButton';
import { Typography } from 'shared/components/Typography';

type UsersConfirmDialogContentPropTypes = {
  title: string;
  bodyText: string;
  submitButtonText: string;
  onSubmit: () => void;
};

export const UsersConfirmDialogContent = ({
  title,
  bodyText,
  submitButtonText,
  onSubmit = noop,
}: UsersConfirmDialogContentPropTypes) => {
  return (
    <>
      <ModalHeader>
        <Typography as="h3" type="body" fontWeight="semibold" color="black">
          {title}
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography color="gray" type="small">
          {bodyText}
        </Typography>
      </ModalBody>
      <ModalFooter>
        <ModalButton variant="outline">Cancel</ModalButton>
        <ModalButton
          color={VARIANTS.PRIMARY}
          dataTestid="delete-session-window-btn"
          onClick={onSubmit}
        >
          {submitButtonText}
        </ModalButton>
      </ModalFooter>
    </>
  );
};
